import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { chargebacksDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useCompleteChargebackMutation = (creditReviewId: string) => {
	const dispatch = useDispatch();

	return useMutation(
		() => {
			return chargebacksDetailsService.completeChargeback(creditReviewId);
		},
		{
			onSuccess(_result) {},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useCompleteChargebackMutation;
